<template>
	<div class='lease-data wrapper'>
		<div class='grid'>
			<span
				class='label'
				:class='{ "not-match": !isMatch(values["land_category"]) }'
			>
				Категория земель в соответствии с земельным кодексом
			</span>

			<custom-p-select
				v-model='values.land_category.value'
				:options="info_land_categories"
				:disabled='!actLpoIsDraft'
			/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["forest_use"]) }'
			>
				Вид разрешенного использования лесов
			</span>
			<custom-p-select
				v-model='values.forest_use.value'
				:options="info_forest_use"
				:disabled='!actLpoIsDraft'
			/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["tenant"]) }'
			>
				Пользователь участка
			</span>
			<custom-p-input v-model='values.tenant.value' :disabled='!actLpoIsDraft'/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["lease_type"]) }'
			>
				Право пользования
			</span>
			<custom-p-select
				v-model='values.lease_type.value'
				:options="info_lease_types"
				:disabled='!actLpoIsDraft'
			/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["lease_contract_type"]) }'
			>
				Документ на право пользования
			</span>

			<custom-p-select
				v-model='values.lease_contract_type.value'
				:options="info_lease_contract_types"
				:disabled='!actLpoIsDraft'
			/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["lease_contract_num"]) }'
			>
				Номер документа о праве пользования
			</span>
			<custom-p-input v-model='values.lease_contract_num.value' :disabled='!actLpoIsDraft'/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["lease_contract_date"]) }'
			>
				Дата документа о праве пользования
			</span>
			<input type='date' v-model='values.lease_contract_date.value' class='custom-input' :disabled='!actLpoIsDraft'>
			
			<span
				class='label'
				:class='{ "not-match": !isMatch(values["lease_additional_info"]) }'
			>
				Добавить информацию о дополнительных <br> соглашениях к документу о праве <br> пользования
			</span>
			<custom-p-input v-model='values.lease_additional_info.value' :disabled='!actLpoIsDraft'/>

			<span
				class='label'
				:class='{ "not-match": !isMatch(values["cadastral_num"]) }'
			>
				Кадастровый номер
			</span>
			<custom-p-input v-model='values.cadastral_num.value' :disabled='!actLpoIsDraft'/>
		</div>

		<div class='not-match-block values-btn-row' v-if='notMatchingValues.length'>

			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

		<div class='lease-comments-block-outer'>
			<CommentsBlock/>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import CommentsBlock from './LeaseData__comment';

	export default {
		name: 'LeaseData',
		components: {
			CommentsBlock
		},
		data() {
			return {

				values: {
					land_category: {
						field: 'land_cat_id',
						inputType: 'select',
						value: null,
						catalog: 'info_land_categories'
					},

					forest_use: {
						field: 'forest_use_id',
						inputType: 'select',
						value: null,
						catalog: 'info_forest_use'
					},

					tenant: {
						field: 'tenant',
						inputType: 'input',
						value: null
					},

					lease_type: {
						field: 'lease_type_id',
						inputType: 'select',
						value: null,
						catalog: 'info_lease_types'
					},

					lease_contract_type: {
						field: 'lease_contract_type_id',
						inputType: 'select',
						value: null,
						catalog: 'info_lease_contract_types'
					},

					lease_contract_num: {
						field: 'lease_contract_num',
						inputType: 'input',
						value: null
					},

					lease_contract_date: {
						field: 'lease_contract_date',
						inputType: 'input',
						value: null
					},

					cadastral_num: {
						field: 'cadastral_num',
						inputType: 'input',
						value: null
					},
					lease_additional_info: {
						field: 'lease_additional_info',
						inputType: 'input',
						value: null
					}
				},

				catalogsAreLoading: false

			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			...mapState({
				selectedLease: state => state.actLpo.lease['lease'],

				info_land_categories: state => state.catalogs['info_land_categories'],
				info_forest_use: state => state.catalogs['info_forest_use'],
				info_lease_types: state => state.catalogs['info_lease_types'],
				info_lease_contract_types: state => state.catalogs['info_lease_contract_types'],
			})
		},

		watch: {
			selectedLease(selectedLease) {
				this.resetValues();
			}
		},

		methods: {
			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
						// value: inputTypeIsSelect ? (this.values[value_name].value === null ? null : this.values[value_name].value.id) : this.values[value_name].value,
					};
					valueList.push(temp);
				}

				this.saveGeneralValue(valueList).then(res => {
					return this.updateLease();
				});
			},
			cancel() {
				this.resetValues();
			},

			resetValues(...valueList) {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'input') {
						value.value = this.selectedLease[value.field];
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.selectedLease[value.field];
						});
						value.value = temp ? temp : null;
					}

				}
			},

			isMatch(value) {
				if (!this.selectedLease) {
					return true;
				}

				if (this.catalogsAreLoading) {
					return true;
				}

				// console.log(value);

				if (value.inputType === 'input') {
					return value.value === this.selectedLease[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.selectedLease[value.field] === null;
					} else {
						return value.value.id === this.selectedLease[value.field];
					}
				}
				return false;
			},

			...mapActions('actLpo', [
				'getLease',
				'saveGeneralValue',
				'updateLease',
			])

		},

		created() {
			// console.log('lsdkfjasldfkj ')

			this.getLease();

			const catalogs = [
				'info_land_categories',
				'info_forest_use',
				'info_lease_types',
				'info_lease_contract_types'
			];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				if (this.selectedLease) {
					this.resetValues();
				}
				
			});
		}
	};
</script>

<style scoped src='@/style/wrapper.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	.lease-geometry-block-outer {
		margin-top: 20px;
	}

	.lease-data {
		padding-top: 30px;
		padding-bottom: 30px;
	}

	.grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 20px;
		align-items: center;
	}
	.label {
		justify-self: end;
		font-weight: bold;
	}

	.not-match {
		background-color: orange;
	}

	/*input {
		border: none;
		border-bottom: 1px solid black;
		outline: none;
		font-size: 14px;
	}*/

	.lease-comments-block-outer {
		margin-top: 30px;
	}
</style>